import * as React from 'react';
import * as QRCode from 'qrcode.react';
import styled from '../theme';

const QRCodeTile = (props: { value: string }) => (
    <div>
        {/* <QRCode value={this.props.value} /> */}
        <StyledQR value={props.value} size={200} />
    </div>
)

export default QRCodeTile

const StyledQR = styled(QRCode)`
    padding: 20px;
    margin: 30px;
    background: #ffffff;
`



// WEBPACK FOOTER //
// ./src/components/QRCodeTile.tsx